export enum FormErrors {
  api = 'api',
  required = 'required',
  word = 'word',
  availableChars = 'availableChars',
}
